import { RequiredAsterisk } from "../required-asterisk"

interface FormInputTextProps {
    label: string
    keyName: string
    isRequired?: boolean
    className?: string
    onAddBtn?: () => void
    value: string | number
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    isNumberInput?: boolean
    isDisabled?: boolean
    placeholder?: string
    maxLength?: number
}

export const FormInputText: React.FC<FormInputTextProps> = (
    { label, keyName, isRequired, className, onAddBtn, value, onChange, isNumberInput = false, isDisabled = false, placeholder, maxLength }
) => {
    const mbClassName = className?.includes('end-section') ? "mb" : ""
    return <>
        <div className={mbClassName}>
            <label htmlFor={keyName}>{label}</label>
            {isRequired && <RequiredAsterisk />}
        </div>

        <input type={isNumberInput ? "number" : "text"} name={keyName} id={keyName}
            className={className || ""} value={value} onChange={onChange} disabled={isDisabled}
            placeholder={placeholder} maxLength={maxLength}
        />

        {onAddBtn && <button className={`add-btn ${mbClassName}`} title="Add" onClick={onAddBtn}>+</button>}
        {!onAddBtn && !className?.includes('span-2') && <span className={mbClassName}></span>}
    </>
}
